import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Slider from '../../../components/Slider/Slider';
import GenericAttachment from '../../../components/Attachment/GenericAttachment';
import FileAttachment from '../../../components/Attachment/FileAttachment';
import ImageAttachment from '../../../components/Attachment/ImageAttachment';
import VideoAttachment from '../../../components/Attachment/VideoAttachment';
import { AttachmentType, attachmentShape } from '../../../utils/attachments';

import {
  AttachmentSliderContainer,
  AttachmentCard,
} from './styles';

const MediaComponents = {
  [AttachmentType.FILE]: FileAttachment,
  [AttachmentType.IMAGE]: ImageAttachment,
  [AttachmentType.VIDEO]: VideoAttachment,
};

const AttachmentSlider = ({ attachments }) => {
  const getAttachmentComponents = useCallback(() => (
    attachments.map((attachment) => {
      const Component = MediaComponents[attachment.type];
      return (
        <AttachmentCard key={attachment.title}>
          <GenericAttachment
            attachment={attachment}
            AttachmentComponent={Component}
          />
        </AttachmentCard>
      );
    })
  ), [attachments]);

  return (
    <AttachmentSliderContainer>
      <Slider>
        {getAttachmentComponents()}
      </Slider>
    </AttachmentSliderContainer>
  );
};

AttachmentSlider.propTypes = {
  attachments: PropTypes.arrayOf(attachmentShape).isRequired,
};

export default AttachmentSlider;
